<template>
  <PolicyPage
    :key="$route.params.type"
    :endpoint="pageTypeOptions.endpoint"
    :pageTitle="$t(pageTypeOptions.pageTitle)"
    :sidebarHeader="$t(pageTypeOptions.sidebarHeader)"
    :showSidebar="true"
  />
</template>

<script>
import PolicyPage from "@/components/PolicyPage.vue";

export default {
  name: "PolicyPagesDynamic",
  components: { PolicyPage },
  computed: {
    pageTypeOptions() {
      const type = this.$route.params.type;

      const map = {
        terms: {
          endpoint: `${process.env.VUE_APP_API_URL}/terms-and-conditions/`,
          pageTitle: "policyPages.termsAndConditions",
          sidebarHeader: "policyPages.regulations",
        },
        privacy: {
          endpoint: `${process.env.VUE_APP_API_URL}/confidentiality-policy/`,
          pageTitle: "policyPages.privacyPolicy",
          sidebarHeader: "policyPages.privacyPolicy",
        },
        about: {
          endpoint: `${process.env.VUE_APP_API_URL}/about-us/`,
          pageTitle: "policyPages.aboutUs",
          sidebarHeader: "policyPages.aboutUs",
        },
      };

      return map[type];
    },
  },
};
</script>
